export const NODE_WIDTH = 220 as const;
export const NODE_HEIGHT = 60 as const;
